var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parogram-index"},[_c('Header'),_vm._v(" "),_c('Banner'),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","background-color":"#f4f4f4"}},[_c('RecentMatch')],1),_vm._v(" "),_c('PlayerRanking'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cd05e7e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/program/ProgramIndex.vue
// module id = null
// module chunks = 